import React from 'react';
import { motion } from 'framer-motion';
import { useFormContext } from '../../context/FormContext';
import { Card } from '../ui/Card';

export const MethodSelector = () => {
  const { data, updateData } = useFormContext();

  return (
    <Card className="mb-8">
      <div className="mb-6">
        <h3 className="text-[10px] font-bold text-brand-muted uppercase tracking-widest mb-2">Start Here</h3>
        <h2 className="text-2xl font-serif text-brand-text">Pick the clearest way to submit.</h2>
        <p className="text-sm text-brand-muted mt-1">Both options send the same structured RFI payload.</p>
      </div>

      <div className="relative flex p-1 bg-brand-light rounded-xl max-w-md">
        {['upload', 'form'].map((method) => (
          <button
            key={method}
            onClick={() => updateData('method', null, method)}
            className={`relative flex-1 py-2.5 text-sm font-medium z-10 transition-colors ${
              data.method === method ? 'text-brand-text' : 'text-brand-muted hover:text-brand-text'
            }`}
          >
            {method === 'upload' ? 'Workbook Upload' : 'Complete Form'}
          </button>
        ))}
        
        {/* Animated background pill */}
        <motion.div
          className="absolute top-1 bottom-1 w-[calc(50%-4px)] bg-white rounded-lg shadow-sm"
          initial={false}
          animate={{
            x: data.method === 'upload' ? 0 : '100%',
          }}
          transition={{ type: 'spring', bounce: 0.2, duration: 0.5 }}
        />
      </div>

      <div className="mt-6 p-4 bg-brand-light/50 rounded-lg border border-brand-border text-sm text-brand-muted">
        {data.method === 'upload' 
          ? "Use this option if the Excel workbook is already completed. When you submit, the workbook is parsed and the payload is sent immediately."
          : "Use this option to manually enter your data. The structured payload is built as you type and sent when you submit."}
      </div>
    </Card>
  );
};